import { VehicleFuelType } from "@1games-ru/region-shared/dist/enums/vehicle/vehicle";
import { cn } from "@/core/helpers/cn";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  selectedFuelAmountSelector,
  selectedFuelGradeSelector,
  selectedFuelTypeSelector,
  selectedPaymentTypeSelector,
  stationSelector,
  vehicleSelector,
} from "@/domains/gasStation/slice";
import useHandlers from "@/domains/gasStation/hooks/useHandlers";
import GasStationFuelAmount from "@/domains/gasStation/components/GasStationFuelAmount.tsx";
import GasStationFuelType from "@/domains/gasStation/components/GasStationFuelType";
import GasStationPaymentType from "@/domains/gasStation/components/GasStationPaymentType";
import GasStationPurchaseDetails from "@/domains/gasStation/components/GasStationPurchaseDetails";

type Props = {
  className?: string;
};
export default function GasStationFormContainer({ className }: Props) {
  const { changeFuelQuantityHandler, changeFuelTypeHandler, changePaymentTypeHandler } =
    useHandlers();
  const station = useAppSelector(stationSelector);
  const vehicle = useAppSelector(vehicleSelector);

  const selectedFuelType = useAppSelector(selectedFuelTypeSelector);

  const selectedFuelGrade = useAppSelector(selectedFuelGradeSelector);
  const selectedFuelAmount = useAppSelector(selectedFuelAmountSelector);
  const selectedPaymentType = useAppSelector(selectedPaymentTypeSelector);

  const isElectric = vehicle.fuelType === VehicleFuelType.Electric;

  return (
    <div className={cn("flex flex-col gap-5", className)}>
      <GasStationFuelType
        vehicleFuelType={vehicle.fuelType}
        fuelTypes={station.fuelTypes}
        selectedFuelType={selectedFuelType}
        selectedGrade={selectedFuelGrade}
        onChange={changeFuelTypeHandler}
      />
      <GasStationFuelAmount
        isElectric={isElectric}
        selectedFuelAmount={selectedFuelAmount}
        vehicleFuelMaxAmount={vehicle.fuelMaxAmount}
        vehicleFuelAmount={vehicle.fuelAmount}
        onChange={changeFuelQuantityHandler}
      />
      <GasStationPaymentType value={selectedPaymentType} onChange={changePaymentTypeHandler} />
      <GasStationPurchaseDetails
        className="mt-auto"
        fuelTypes={station.fuelTypes}
        selectedFuelAmount={selectedFuelAmount}
        selectedFuelType={selectedFuelType}
        selectedFuelGrade={selectedFuelGrade}
      />
    </div>
  );
}
